import { Box, Stack, Typography } from "@mui/material";
import React from "react";
import { ColletteIconButton } from "@collette-travel/collette-common-controls";
import { Close } from "@mui/icons-material";
import { BasicInfo } from "@/types/dto/common/basic-info";

interface BestTimeToTravelModalProps {
  handleClose: () => void;
  bestTimeToTravelProps?: BasicInfo;
}

const BestTimeToTravelModal = ({
  handleClose,
  bestTimeToTravelProps
}: BestTimeToTravelModalProps) => (
  <Stack
    sx={{
      p: { xs: "2.4rem", sm: "4rem", md: "4rem 6rem" },
      maxWidth: "82rem",
      maxHeight: "80vh",
      gap: "2.4rem",
      position: "relative",
      overflow: "hidden"
    }}
    data-testid="best-time-to-travel-modal"
  >
    <Typography
      id="modal-modal-title"
      variant="h5"
      component="h2"
      textAlign="left"
      data-testid="best-time-to-travel-modal-title"
      sx={{ flexShrink: 0 }}
    >
      {bestTimeToTravelProps?.headerText}
    </Typography>

    <Box
      sx={{
        textAlign: "left",
        overflowY: "auto",
        flex: 1,
        minHeight: 0
      }}
      data-testid="best-time-to-travel-modal-content"
    >
      <Typography
        component="div"
        data-testid="best-time-to-travel-modal-description"
        dangerouslySetInnerHTML={{
          __html: bestTimeToTravelProps?.copyText || ""
        }}
      />
    </Box>
    <ColletteIconButton
      testId="best-time-to-travel-modal-close-button"
      onClick={handleClose}
      sx={{
        position: "absolute",
        top: "1.6rem",
        right: "1.6rem"
      }}
    >
      <Close />
    </ColletteIconButton>
  </Stack>
);

export default BestTimeToTravelModal;
